import { CellContext } from "@tanstack/react-table";
import TableCellActions from "../../../ui/Table/TableCellActions";
import IconButton from "../../../ui/IconButton/IconButton";
import { Copy, PlayCircle, PlusCircle } from "../../../ui/Icon/Icon";
import { useDisclosure } from "../../../ui/util/useDisclosure";
import { useToast } from "../../../ui/Toast/ToastContext";
import styles from "./KeywordCell.module.scss";
import { graphql } from "../../../__generated__/gql";
import { useMutation } from "urql";
import GenerateArticleFromKeywordModal from "./GenerateArticleFromKeywordModal";
import Truncate from "../../../ui/Truncate/Truncate";

const AddKeywordAsDraftMutation = graphql(/* GraphQL */ `
  mutation addKeywordAsDraft($keyword: String!) {
    createArticle(input: { keyword: $keyword, draft: true }) {
      ... on Article {
        id
      }
    }
  }
`);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function KeywordCell({ cell }: CellContext<any, string>) {
  const { showToast } = useToast();

  const [generateFromKeywordModalOpened, generateFromKeywordModal] =
    useDisclosure();

  const [, addKeywordAsDraft] = useMutation(AddKeywordAsDraftMutation);

  return (
    <div className={styles.keyword}>
      <Truncate>{cell.getValue()}</Truncate>
      <TableCellActions>
        <IconButton
          hover="primary"
          aria-label="Generate article"
          IconComponent={PlayCircle}
          onClick={generateFromKeywordModal.open}
        />
        <IconButton
          hover="primary"
          aria-label="Create draft article (free)"
          IconComponent={PlusCircle}
          onClick={async () => {
            const response = await addKeywordAsDraft({
              keyword: cell.getValue(),
            });

            if (!response.error) {
              showToast({
                title: "Keyword added as draft",
              });
            }
          }}
        />
        <IconButton
          hover="primary"
          aria-label="Copy keyword"
          IconComponent={Copy}
          onClick={async () => {
            await navigator.clipboard.writeText(cell.getValue());

            showToast({
              title: "Copied to clipboard",
            });
          }}
        />

        <GenerateArticleFromKeywordModal
          isOpen={generateFromKeywordModalOpened}
          onClose={generateFromKeywordModal.close}
          keyword={cell.getValue()}
        />
      </TableCellActions>
    </div>
  );
}

export default KeywordCell;
